<template>
  <a-modal :visible="visible" width="450px" :footer="null" centered @cancel="handleCloseModal">
    <div class="container__inactive">
      <img class="image__delete" :src="questionCircleUrl" alt="question" />
      <h1 class="text__alert">
        ¿Estás seguro de desactivar este 
        {{ isIdentifier ? "identificador" : "canal" }} de 
        {{ record?.channel_name }} asociado a {{ record?.associate }}?
      </h1>
    </div>
    <p class="text">Recuerda que se tomarán las siguientes acciones:</p>
    <ul>
      <li>{{ firstText }}</li>
      <li>{{ secondText }}</li>
      <li 
        v-if="
          (record.channel_id === ChannelType.Whatsapp && record.data_parameters.enable_voice) || 
          record.channel_id === ChannelType.Email"
      >
        {{ thirdText }}
      </li>
    </ul>

    <div class="button__disabled">
      <a-button
        style="width: 100%"
        :disabled="disabled"
        class="footer__delete"
        type="primary"
        @click="fetchDeactivate"
      >
        Desactivar {{ isIdentifier ? "identificador" : "canal" }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import { channelStatus } from "@/app/channels/utils/constants";
import { message } from "ant-design-vue";
import { fbUnlinkPage } from "@/app/channels/utils/facebookManager";
import { ChannelType } from "@/app/shared/utils/enums";

import questionCircleUrl from "@/app/common/assets/question-circle.png?url";

export default defineComponent({
  name: "DeactivateChannel",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      questionCircleUrl,
      ChannelType,
    };
  },
  computed: {
    firstText() {
      if (this.record.channel_id === ChannelType.Whatsapp) {
        if (this.record.data_parameters.enable_voice) {
          return "Se desactivará el identificador de WhatsApp Voice asociado a este número."
        } else {
          return "Todas las interacciones asociadas únicamente a este identificador serán finalizadas."
        }
      }
      if (this.record.channel_id === ChannelType.WhatsappVoice) {
        return "Todas las interacciones asociadas únicamente a este identificador serán finalizadas."
      }
      return "Todas las interacciones asociadas unicamente a este canal serán finalizadas"
    },
    secondText() {
      if (this.record.channel_id === 7) {
        return "Este canal de voz será desactivado y todas las llamadas serán cortadas";
      }
      if (this.record.channel_id === 2) {
        return "Este canal de SMS será desactivado";
      }
      if (this.record.channel_id === ChannelType.Whatsapp) {
        if (this.record.data_parameters.enable_voice) {
          return "Todas las interacciones asociadas a este identificador de WhatsApp Message y Voice serán finalizadas.";
        } else {
          return "Este identificador de WhatsApp Message se desvinculará de las colas en las que esté asociada."
        }
      }
      if (this.record.channel_id === 5) {
        return "Este canal de Web Chat se desactivará de las colas que estén asociadas.";
      }
      if (this.record.channel_id === 6) {
        return "Este canal de Facebook Messenger se desactivará de las colas que estén asociadas.";
      }
      if (this.record.channel_id === ChannelType.WhatsappVoice) {
        return "Este identificador de WhatsApp Voice se desvinculará de las colas e IVRs en las que esté asociado.";
      }
      return "Este canal se desactivará de las colas que estén asociadas.";
    },
    isIdentifier() {
      const id = this.record?.channel_id
      return [ChannelType.Whatsapp, ChannelType.WhatsappVoice].includes(id)
    },
    thirdText() {
      if (this.record.channel_id === ChannelType.Whatsapp) {
        return "Este identificador de WhatsApp Message y Voice se desvinculará de las colas o IVRs en las que esté asociada."
      }
      if (this.record.channel_id === ChannelType.Email) {
        return "Se descartarán todos los borradores que los usuarios tengan asociados a este identificador."
      }
    },
  },
  methods: {
    async fetchDeactivate() {
      try {
        const data = {
          id: this.record.id,
          status: channelStatus.inactive,
        };

        if (this.record.channel_id === 6 && this.record.data_parameters) {
          await Promise.all([
            fbUnlinkPage({
              pageId: this.record.data_parameters.id,
              pageAccessToken: this.record.data_parameters.token,
            }),
            this.$store.dispatch("updateChannelCreate", data),
          ]);
        } else {
          await this.$store.dispatch("updateChannelCreate", data);
        }

        this.$message.success(
          `Se desactivo el canal de ${this.record.provider_name} asociado a ${this.record.associate}.`
        );
        this.$emit("reloadTable");
        this.$emit("onClose");
      } catch (error) {
        const errorMessage = error?.getErrorMessage() || "Ha courrido un error";

        message.warning(errorMessage);
      }
    },
    handleCloseModal() {
      this.$emit("onClose");
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 18px
  font-weight: 600

.text
  margin-bottom: 20px

.button__disabled
  margin-top: 10px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
</style>
